<template>
  <div
    class="wrapper-inside text-left"
  >
    <GoBackButton />
    <hr>
    <div
      v-if="referral"
      class="text-right mb-2"
    >
      <b-button
        :variant="referral.is_disabled ? 'success' : 'danger'"
        size="sm"
        @click="toggle"
      >
        {{
          referral.is_disabled
            ? $t('pages.admin.referrals.referral.enable', 'Enable')
            : $t('pages.admin.referrals.referral.disable', 'Disable')
        }}
      </b-button>
    </div>
    <div
      v-if="referral"
      class="mb-4"
    >
      <h1 class="title mb-2">
        <div>{{ $t('pages.admin.referrals.referral.title', 'Update Referral') }}</div>
        <small>{{ referral.title }}</small>
      </h1>
      <h1 class="subtitle">
        <div class="row">
          <div class="col text-left">
            {{ $t('pages.admin.referrals.referral.link', 'Link') }}
          </div>
          <div class="col text-right">
            <span :class="referral.is_disabled ? 'text-danger' : 'text-success'">
              {{
                referral.is_disabled
                  ? $t('pages.admin.referrals.referral.disabled', 'Disabled')
                  : $t('pages.admin.referrals.referral.enabled', 'Enabled')
              }}
            </span>
          </div>
        </div>
      </h1>
      <div class="referral-link p-2 mb-2">
        {{ url(referral) }}
      </div>
      <div class="sm-text pb-1">
        {{ $t('pages.admin.referrals.referral.counter', 'Counter') }}
        {{ referral.count }}
      </div>
      <div class="sm-text pb-1">
        <font-awesome-icon
          icon="clock"
        /> {{ $t('pages.admin.referrals.referral.created-at', 'Created at') }}
        {{ referral.created_at }}
      </div>
      <div class="sm-text pb-1">
        <font-awesome-icon
          icon="clock"
        /> {{ $t('pages.admin.referrals.referral.updated-at', 'Updated at') }}
        {{ referral.updated_at }}
      </div>
    </div>
    <div v-if="referral !== null">
      <h1 class="title mb-2">
        {{ $t('pages.admin.referrals.referral.referred-users', 'Referred users') }}
      </h1>
      <b-card>
        <b-card-body
          v-if="referral && referral.users && referral.users.length"
        >
          <UserCard
            v-for="user in referral.users"
            :key="user.id"
            :user="user"
          />
        </b-card-body>
        <b-card-body
          v-else
          class="p-5 text-center"
        >
          {{ $t('pages.admin.referrals.referral.no-users-referred', 'No users referred') }}
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import GoBackButton from '@/components/jobs/shared/GoBackButton';
import UserCard from '@/components/jobs/admin/UserCard';

export default {
    components: {
      UserCard,
      GoBackButton
    },
    data() {
      return {
        referral: null
      }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.axios.get('/referral/' + this.$route.params.id)
        .then(response => {
          this.referral = response.data;
        })
        .catch(() => {
          this.$toastSomethingWentWrong();
        });
    },

    toggle() {
      this.axios.post('/referral/edit', {
        id: this.referral.id,
        is_disabled: !this.referral.is_disabled,
      })
        .then(() => {
          this.referral.is_disabled = !this.referral.is_disabled;
          this.$toastNotification('success', '',
              this.referral.is_disabled
                  ? this.$t('pages.admin.referrals.disable-success', 'Referral disabled')
                  : this.$t('pages.admin.referrals.enable-success', 'Referral enabled'),
          );
        })
        .catch(() => {
          this.$toastSomethingWentWrong();
        });
    },

    url(referral) {
        return `${window.location.origin}/?ref=${referral.hash}`;
    },
  }
}
</script>

<style lang="scss" scoped>
  .card {
    background: #f2f2f2;
  }

  .referral-link {
    background: rgba(0, 0, 0, 0.1);
    padding-left: 3em;
    text-align: left;
    font-size: 0.8rem;
  }

  .status-change-btn {
    padding: 3px 10px;
    font-size: 0.9rem;
    font-weight: 600;
    margin: 0 3px;
  }

  h1.name {
    font-size: 1.5rem !important;
  }

  h1.title {
    font-size: 1.4rem !important;
    color: #009090;
    margin: 0;
  }

  .subtitle {
    color: #009090;
    font-size: 0.7rem !important;
    text-transform: uppercase;
  }

  h1.contact {
    color: rgb(80, 80, 80);
    font-size: 1.2rem !important;
    margin-bottom: 0;
  }

  .status {
    color: #777;
    font-size: 1rem !important;
    font-weight: 600;
    text-align: center;
    margin-top: 0.5rem;

    span.confirmed {
      color: #28a745;
    }

    span.pending {
      color: #ffc107;
    }

    span.rejected {
      color: #dc3545;
    }
  }

  .cv-avatar {
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }

  .cif {
    color: #999;
    font-weight: 600;
    font-size: 1.2rem;

    span {
      font-size: 1rem;
    }
  }

  .description {
    margin: 0.6rem 0;
    font-size: 0.9rem;
    white-space: pre-line
  }

  .sm-text {
    font-size: 0.9rem;
    color: #666;
  }

  @media screen and (min-width: 768px) {
    .one-company {
      width: 70%;
    }
  }
</style>
